import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { Main } from 'components/frame/main';
import { SideMenu } from 'components/utils/side-menu';
import { Form } from 'components/pages-kritik-dan-saran/form';
import { TagNavigation } from 'components/pages-article-detail/tag-navigation';
import { RelateContent } from 'components/pages-article-detail/relate-content';

export const KritikDanSaran = () => {

    let { slug } = useParams();
    const [DataResponse, setDataResponse] = useState();
    const [FadeClassName, setFadeClassName] = useState('fade-costum hide');
    useEffect(() => {

        setFadeClassName('fade-costum')
        return () => {
            setDataResponse(null);
            setFadeClassName('fade-costum hide');
        };
    }, [slug]);

    return (
        <Main>
            <section id="content_main " className={'clearfix jl_post_loop_wrapper ' + FadeClassName}>
                <div className="container margin-list">
                    <div className="row">
                        <div className="col-md-12 loop-large-post" id="content">
                            <div className="widget_container content_page">
                                <div className="post-2970 post type-post status-publish format-gallery has-post-thumbnail hentry category-business tag-inspiration tag-morning tag-tip tag-tutorial post_format-post-format-gallery" id="post-2970">
                                    <div className="single_section_content box blog_large_post_style">
                                        <Form/>
                                        <div className="clearfix" ></div>
                                        <div className="single_tag_share">
                                            <div className="tag-cat">
                                                {/* <TagNavigation slug={slug}/> */}
                                            </div>
                                        </div>
                                        {/* {
                                            (DataResponse != null) ?
                                                <RelateContent category_id={DataResponse.id_kategori_artikel}/> : 'Loading ...'
                                        } */}
                                    </div>
                                </div>
                                <div className="brack_space" />
                            </div>
                        </div>
                        {/* <div className="col-md-4" id="sidebar">
                            <SideMenu page_type={'artikel'}/>
                        </div> */}
                    </div>
                </div>
            </section>
        </Main>
    )
};